<template>
  <div class="secondary-body">
    <div class="container">
      <div class="column left"></div>
      <div class="column middle">
        <div class="site-logo">
          <img :src="userStore.logoSourceWhite" alt="cineflares" />
        </div>
      </div>
      <div class="column right"></div>
    </div>
    <section id="card-section">
      <div class="column left"></div>
      <div class="middle" v-if="newsStore.news">
        <div class="card-container">
          <h3 class="secondary-title">News</h3>
          <div v-if="loading" class="loader-div">
            <div class="loader"></div>
          </div>
          <div v-else>
            <div>
              <CardComponent
                v-for="(newsItem, index) in newsStore.news"
                :key="index"
                :title="newsItem.title"
                :description="newsItem.description"
                :date="newsItem.createdAt"
                :imageUrl="newsItem.imageUrl"
                :additionalImages="newsItem.additionalImages"
              />
            </div>
            <PaginationBox
              :current-page="newsStore.getCurrentPage"
              :total-pages="newsStore.getTotalPages"
              @page-change="handlePageChange"
            />
          </div>
        </div>
      </div>
      <div class="column right"></div>
    </section>
  </div>
</template>

<script setup>
import '../styles/News.css'
import CardComponent from '../components/CardComponent.vue'
import PaginationBox from '../components/PaginationBox.vue'
import { onBeforeMount, onUnmounted, ref } from 'vue'
import { useNewsStore } from '@/stores/News'
import { useUsersStore } from '@/stores/Users'
import { useToastStore } from '@/stores/Toast'
const loading = ref(false)
const toast = useToastStore()

const userStore = useUsersStore()
const newsStore = useNewsStore()

const fetchNews = async (page = 1) => {
  try {
    loading.value = true
    await newsStore.fetchNews(page)
  } catch (error) {
    console.error('Error fetching news:', error)
    toast.showToast('error', 'Failed to fetch news. Please try again later.')
  } finally {
    loading.value = false
  }
}

const handlePageChange = async page => {
  fetchNews(page)
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onBeforeMount(async () => {
  fetchNews()
  document.querySelector('body').classList.add('backgroundImage')
})

onUnmounted(() => {
  document.querySelector('body').classList.remove('backgroundImage')
})
</script>
